import React from 'react'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import { pluralizeToString } from 'lib/string/pluralize'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import { PackageOptionUpgradeView } from './PackageUpgradeModal'
import getPackageUpgradePrice from './getPackageUpgradePrice'
import PackageUpgradePriceStack from './PackageUpgradePriceStack'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCharterBundleRoute } from 'selectors/offerPage/initialOfferPageStateSelectors'

interface Props {
  packageUpgrade: PackageOptionUpgradeView
  hasFlightsSelected?: boolean
}

function LePackageUpgradePrice({
  packageUpgrade,
  hasFlightsSelected,
}: Props) {
  const charterBundleRoute = useAppSelector(state => getCharterBundleRoute(state, packageUpgrade.offer))
  const { total, isSamePrice, price, memberPrice, duration } = getPackageUpgradePrice(packageUpgrade, hasFlightsSelected, charterBundleRoute)

  return <div>
    {isSamePrice && <PriceRowPrice
      size="M"
      price={price}
      signDisplay="always"
      saleUnit=""
    />}
    {!isSamePrice &&
      <PackageUpgradePriceStack
        price={price}
        memberPrice={memberPrice}
        offerConfig={packageUpgrade.offer.luxPlus}
      />}
    <PriceRowCaption>
      <FormatCurrency value={total} /> total for {pluralizeToString('night', duration)}
    </PriceRowCaption>
  </div>
}

export default LePackageUpgradePrice
